<p>manage-job works!</p>
